export default "__VITE_ASSET__DcdsFuL1__"